import { apiConcurso } from './cliente';

/**
 * Abre em nova aba um arquivo enviado no formulário dinâmico ([{ path, nome, tamanho }]).
 * GET /formulario/arquivos?path=... devolve uma SAS URL efêmera. A aba é pré-aberta
 * de forma síncrona (tem que ser chamada direto do click) pra escapar do pop-up blocker.
 * Lança o erro da requisição pra quem chamou exibir a mensagem.
 */
export async function abrirArquivoFormulario(path) {
  const win = window.open('about:blank', '_blank');
  try {
    const res = await apiConcurso.get('/api/v1/formulario/arquivos', { params: { path } });
    const url = res.data?.data?.url;
    if (url && win) win.location.href = url;
    else if (win) win.close();
  } catch (err) {
    if (win) win.close();
    throw err;
  }
}
